module.exports = __webpack_public_path__ + "static/media/new_top.770c9af5.jpg";